export default "__VITE_ASSET__BIkBfj04__ 720w";